import { runtimeBasePath as localizedRuntimeBasePath } from "./localeRoutes";

export function runtimeBasePath(slug, locale = null, manifest = null) {
  return localizedRuntimeBasePath(slug, locale, manifest);
}

export function runtimeHomePath(slug, locale = null, manifest = null) {
  return runtimeBasePath(slug, locale, manifest);
}

export function runtimeSearchPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/search`;
}

export function runtimeContactPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/contact`;
}

export function runtimeSavedListingsPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/saved-listings`;
}

export function runtimeSavedSearchesPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/saved-searches`;
}

export function runtimeListingPath(slug, listingId, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/listings/${listingId}`;
}

export function runtimeVehicleSearchPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/vehicles`;
}

export function runtimeVehicleDetailPath(slug, vehicleListingId, locale = null, manifest = null) {
  return `${runtimeVehicleSearchPath(slug, locale, manifest)}/${vehicleListingId}`;
}

export function runtimeDealerDirectoryPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/concesionarios`;
}

export function runtimeDealerProfilePath(slug, dealerSlug, locale = null, manifest = null) {
  return `${runtimeDealerDirectoryPath(slug, locale, manifest)}/${dealerSlug}`;
}

export function runtimeBuyerQuizPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/comprar/quiz`;
}

export function runtimeBuyerQuizResultsPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/comprar/quiz/resultados`;
}

export function runtimeCasaMapaRentQuizPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/arrendar/quiz`;
}

export function runtimeCasaMapaQuizResultsPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/quiz/resultados`;
}

export function runtimeCasaMapaBuyingGuidePath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/guia/comprar`;
}

export function runtimeCasaMapaRentingGuidePath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/guia/arrendar`;
}

export function runtimeCasaMapaSellPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/vender`;
}

export function runtimeCasaMapaAdvertisePath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/anunciar`;
}

/** CasaMapa agency advertise / plans page. */
export function runtimeCasaMapaAgencyPlansPath(slug, locale = null, manifest = null) {
  return `${runtimeCasaMapaAdvertisePath(slug, locale, manifest)}/inmobiliarias`;
}

/** CasaMapa vendor advertise / plans page. */
export function runtimeCasaMapaVendorPlansPath(slug, locale = null, manifest = null) {
  return `${runtimeCasaMapaAdvertisePath(slug, locale, manifest)}/proveedores`;
}

/** CasaMapa service provider directory (M14). */
export function runtimeCasaMapaVendorDirectoryPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/servicios`;
}

/** @deprecated Use runtimeCasaMapaVendorDirectoryPath — legacy proveedores alias */
export function runtimeCasaMapaHomeVendorsPath(slug, locale = null, manifest = null) {
  return runtimeCasaMapaVendorDirectoryPath(slug, locale, manifest);
}

export function runtimeHowItWorksPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/como-funciona`;
}

export function runtimeCasaMapaMarketIntelligencePath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/inteligencia-de-mercado`;
}

export function runtimeCasaMapaInvestorsPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/inversores`;
}

export function runtimeSignInPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/sign-in`;
}

export function runtimeAccountPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/cuenta`;
}

export function runtimeAccountComparePath(slug, locale = null, manifest = null) {
  return `${runtimeAccountPath(slug, locale, manifest)}/comparar`;
}

/** CasaMapa municipality page (custom-domain safe). */
export function runtimeCasaMapaMunicipalityPath(
  slug,
  municipalitySlug,
  locale = null,
  manifest = null
) {
  return `${runtimeBasePath(slug, locale, manifest)}/municipios/${municipalitySlug}`;
}

/** CasaMapa neighborhood page (custom-domain safe). */
export function runtimeCasaMapaNeighborhoodPath(
  slug,
  neighborhoodSlug,
  locale = null,
  manifest = null
) {
  return `${runtimeBasePath(slug, locale, manifest)}/barrios/${neighborhoodSlug}`;
}

/** CasaMapa agency directory. */
export function runtimeCasaMapaAgencyDirectoryPath(slug, locale = null, manifest = null) {
  return `${runtimeBasePath(slug, locale, manifest)}/inmobiliarias`;
}

/** CasaMapa agency profile. */
export function runtimeCasaMapaAgencyProfilePath(
  slug,
  agencySlug,
  locale = null,
  manifest = null
) {
  return `${runtimeCasaMapaAgencyDirectoryPath(slug, locale, manifest)}/${agencySlug}`;
}

export function hrefForManifestPage(slug, page, locale = null, manifest = null) {
  if (!page) {
    return runtimeHomePath(slug, locale, manifest);
  }

  switch (page.template) {
    case "home":
      return runtimeHomePath(slug, locale, manifest);
    case "listing-search":
      return runtimeSearchPath(slug, locale, manifest);
    case "vehicle-search":
      return runtimeVehicleSearchPath(slug, locale, manifest);
    case "vehicle-detail":
      return runtimeVehicleSearchPath(slug, locale, manifest);
    case "contact":
      return runtimeContactPath(slug, locale, manifest);
    case "buyer-concierge-quiz":
      return runtimeBuyerQuizPath(slug, locale, manifest);
    case "buyer-quiz-results":
      return runtimeBuyerQuizResultsPath(slug, locale, manifest);
    case "content":
      if (page.route && page.route !== "/") {
        const route = page.route.startsWith("/") ? page.route : `/${page.route}`;
        return `${runtimeBasePath(slug, locale, manifest)}${route}`;
      }
      return runtimeHomePath(slug, locale, manifest);
    default:
      if (page.route && page.route !== "/") {
        const route = page.route.startsWith("/") ? page.route : `/${page.route}`;
        return `${runtimeBasePath(slug, locale, manifest)}${route}`;
      }
      return runtimeHomePath(slug, locale, manifest);
  }
}

export function resolveContentCtaHref(slug, href, locale = null, manifest = null) {
  if (!href) {
    return runtimeHomePath(slug, locale, manifest);
  }
  if (href.startsWith("http://") || href.startsWith("https://")) {
    return href;
  }
  const path = href.startsWith("/") ? href : `/${href}`;
  return `${runtimeBasePath(slug, locale, manifest)}${path}`;
}
